import { Controller } from '@hotwired/stimulus';


export default class extends Controller {
	static get targets () {
		return ['variant'];
	}

	connect() {
		this.onToggleChange = this.onToggleChange.bind(this);
		document.addEventListener('plan-toggle:change', this.onToggleChange);
	}

	disconnect() {
		document.removeEventListener('plan-toggle:change', this.onToggleChange);
	}

	toggleSection(event) {
		event.currentTarget.closest('.compare-plans-m__section').classList.toggle('active');
	}

	onToggleChange(event) {
		const { toggleId, checked } = event.detail;
		const targetVariant = checked ? 'annual' : 'short';

		this.variantTargets.forEach((variant) => {
			if (variant.dataset.toggleId !== toggleId) {
				return;
			}

			variant.hidden = variant.dataset.variant !== targetVariant;
		});
	}
}
